module.exports = __webpack_public_path__ + "static/yulia_1-ea6960baf118a581eab36e36d4b881b1.jpg";